import { apiFactory } from "../api_factory";

export const revisionsApi = apiFactory({
  path: `/api/v4/revisions/`
});
